import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

export default function SessionWarningModal() {
  const { showSessionWarning, extendSession, logout } = useAuth();

  if (!showSessionWarning) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Session Expiring</h2>
        <p className="text-gray-600 mb-6">
          Your session is about to expire. Would you like to stay logged in?
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={logout}
            className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium"
          >
            Log Out
          </button>
          <button
            onClick={extendSession}
            className="px-4 py-2 text-white bg-blue-600 hover:bg-blue-700 rounded-lg font-medium"
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
}
